import script from "./ViewInspector.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewInspector.vue?vue&type=script&setup=true&lang=js"

import "./ViewInspector.vue?vue&type=style&index=0&id=04f50702&lang=scss"

const __exports__ = script;

export default __exports__